import { useEffect, useState } from 'react';
export const useCurrentUrl = () => {
    const [url, setUrl] = useState(null);
    useEffect(() => {
        setUrl(window.location.pathname + window.location.search || null);
    }, []);
    return url;
};
export const useURLSearchParams = () => {
    const [searchParams, setSearchParams] = useState(null);
    useEffect(() => {
        const search = new URLSearchParams(window.location.search);
        setSearchParams(search);
    }, []);
    return searchParams;
};
//# sourceMappingURL=useCurrentUrl.js.map